<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Clipboard from "svelte-clipboard";
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faSpinner,faGift,faCrown,faCheckDouble,faTimesCircle,faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
    import Time from "svelte-time";
    import Swal from 'sweetalert2'

    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))

    let loading = false
    let bnakDep = {}
    let names;

    let camList = {}
    let isList=  false

    export let params = {};
    let sid
    $: {
        if (params && params.sid) {
            sid = params.sid
            campaignList()
        } 
    }

    async function campaignList() {
        isList = false
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getpromotioncode", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({_id:sid})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            camList = json.payload
            isList = true
		} else {
            push('/promotion')
            throw new Error(json);
		}
    }
    async function checkPromotion(types) {
        Swal.fire({
            title: "กรุณาระบุยอดที่ต้องการเติมเครดิต",
            input: "number",
            inputAttributes: {
                autocapitalize: "off",
                align: "center"
            },
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
            preConfirm: async (login) => {
                try {
                    const res = await fetch(window.localStorage.getItem("apiurl")+"member/checkpromotion", {
                        method: 'POST',
                        headers:{
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                            'x-api-appid': window.localStorage.getItem("appid")
                        },
                        body: qs.stringify({
                            _id:sid,
                            credit:login,
                            coupon:""
                        })
                    })
                    const json = await res.json()
                    return json
                } catch (error) {
                    Swal.showValidationMessage(`
                        Request failed: ${error}
                    `);
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            
            console.log(result)
            if (result.isConfirmed) {
                // Swal.fire({
                // title: `${result.value.login}'s avatar`,
                // imageUrl: result.value.avatar_url
                // });
                if(result.value.statusCode == 200){
                    if(result.value.payload.type == 'F'){
                        Swal.fire("คุณได้รับโปรโมชั่นฟรีเครดิตเรียบร้อยแล้ว")
                        push('/dashboard')
                    }else{
                        Swal.fire({
                            title: "<strong>บันทึกโปรโมชั่นสำเร็จ</strong>",
                            icon: "info",
                            html: `
                                ยอดโอน : <b>`+result.value.payload.credit+`</b><br />
                                โบนัส : <b>`+result.value.payload.bonus+`</b><br />
                                ***กรุณาโอนยอดตามจำนวนที่ระบุเท่านั้น
                            `,
                            showCloseButton: true,
                            showCancelButton: false,
                            focusConfirm: false,
                            confirmButtonText: `Ok`,
                        });
                        push('/deposit')
                    }
                    
                }else{
                    Swal.fire(result.value.message)
                }
            }else{
                
            }
        });
    }
    
</script>
<div class="default-home">
<div class="row pt-2 mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; bacbackground-repeat: no-repeat;
background-attachment: fixed;
background-position: center;">
    <Header />
    
   
    <div class="col-12 text-center mt-3" ><a href="/promotion" use:link style="text-decoration: none;"><h4 style="color: rgb(230, 196, 119) !important;"><Fa icon={faCrown} /> โปรโมชั่น</h4></a></div>
    <div class="col-12" style="min-height: 500px;">
        {#if loading}
        <div class="text-center mt-2" style="">
            <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
        </div>
        {/if}
        {#if !loading}
        <div class="card mt-3 bg-black">
            <div class="card-body">
                <div class="row ps-2 pe-2 text-white">
                    {#if isList}
                    <div class="col-12 text-center mb-2 text-white">
                        {camList.promotion_name}
                    </div>
                    <div class="col-12 border border-1 border-warning rounded p-2  mb-2 text-white">
                        {@html camList.promotion_desc}
                        <br />
                        <br />
                        <h6 class="text-warning">*เงื่อนไข</h6>
                        <span>วันใช้งาน : <span class="text-primary"><Time timestamp="{camList.promotion_start*1000}" format="DD-MM-YYYY" /> - <Time timestamp="{camList.promotion_end*1000}" format="DD-MM-YYYY" /></span></span><br />
                        <span>เวลา : <span class="text-primary">{camList.promotion_start_time} - {camList.promotion_end_time}</span><br />
                        <span>สำหรับสมาชิกใหม่ : </span>
                            {#if camList.promotion_newuser_open == 'O'}
                            <span class="text-success"><Fa icon={faCheckDouble} /> </span>
                            {:else}
                            <span class="text-danger"><Fa icon={faTimesCircle} /> </span>
                            {/if}
                        <br />
                        <span>สำหรับสมาชิกปัจจุบัน : </span>
                            {#if camList.promotion_olduser_open == 'O'}
                            <span class="text-success"><Fa icon={faCheckDouble} /> </span>
                            {:else}
                            <span class="text-danger"><Fa icon={faTimesCircle} /> </span>
                            {/if}
                        <br />
                        <span>เงื่อนไขฝาก : </span><br />
                        {#each camList.promotion_value as itmdep}
                            &nbsp;&nbsp;&nbsp;<span class="text-warning">{itmdep.pro_cash} - {itmdep.pro_to}</span> รับ <span class="text-warning">{itmdep.pro_total}{#if camList.promotion_type == 'P'}%{:else}บาท{/if}
                            </span>ถอนได้ <span class="text-warning">{#if itmdep.pro_withdraw==0}ไม่จำกัด{:else}{itmdep.pro_withdraw}บาท{/if}</span>
                            <br />
                        {/each}
                        
                        <span>เงื่อนไขถอน : </span><br />
                        {#if camList.promotion_withdraw_type == 'T'}
                            &nbsp;&nbsp;&nbsp;<span class="text-warning">{#if camList.promotion_withdarwlimit==0}ไม่จำกัด{:else}{camList.promotion_withdarwlimit}{/if}</span> เทิร์น
                        {:else}
                            &nbsp;&nbsp;&nbsp;<span class="text-warning">{#if camList.promotion_withdarwlimit==0}ไม่จำกัด{:else}{camList.promotion_withdarwlimit}{/if}</span> บาท
                        {/if}
                        <br />
                        <span>ค่ายเกมที่เล่นได้ : </span><br />
                        <div class="row">
                            <div class="col text-center">
                                {#each camList.promotion_platform as itmgame}
                                    <img src="./assets/platform/{itmgame}.png" class=" w-25" alt="{itmgame}">
                                {/each}
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-12 mb-5 text-center">
                        <span class="text-danger">** โปรโมชั่นจะถูก <span class="text-warning">"ยกเลิก"</span> หลังจาก 30 นาที<br /><b>หากไม่เติมเงินเข้ามา</b></span>
                        <button type="button" class="btn btn-warning btn-sm w-100" on:click={() => checkPromotion()}>รับโปรโมชั่น</button>
                    </div>
                    {/if}
                </div>
                
            </div>
        </div>
        {/if}
    </div>
 
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3 blog-promotion">
        <HeaderThemes/>
        <div class="col-12 text-center mt-3" ><a href="/promotion" use:link style="text-decoration: none;"><h4 class="head-title"><Fa icon={faChevronCircleLeft} /> โปรโมชั่น</h4></a></div>
            <div class="col-12" style="min-height: 500px;">
                {#if loading}
                <div class="text-center mt-2" style="">
                    <Fa icon={faSpinner} size="3x" pulse class="text-white"/>
                </div>
                {/if}
                {#if !loading}
                <div class="card mt-3 bg-black">
                    <div class="card-body">
                        <div class="row ps-2 pe-2 text-white">
                            {#if isList}
                            <div class="col-12 text-center mb-2 text-white">
                                {camList.promotion_name}
                            </div>
                            <div class="col-12 border border-1 border-warning rounded p-2  mb-2 text-white mini-blog">
                                {@html camList.promotion_desc}
                                <br />
                                <br />
                                <h6 class="text-warning">*เงื่อนไข</h6>
                                <span>วันใช้งาน : <span class="text-primary"><Time timestamp="{camList.promotion_start*1000}" format="DD-MM-YYYY" /> - <Time timestamp="{camList.promotion_end*1000}" format="DD-MM-YYYY" /></span></span><br />
                                <span>เวลา : <span class="text-primary">{camList.promotion_start_time} - {camList.promotion_end_time}</span><br />
                                <span>สำหรับสมาชิกใหม่ : </span>
                                    {#if camList.promotion_newuser_open == 'O'}
                                    <span class="text-success"><Fa icon={faCheckDouble} /> </span>
                                    {:else}
                                    <span class="text-danger"><Fa icon={faTimesCircle} /> </span>
                                    {/if}
                                <br />
                                <span>สำหรับสมาชิกปัจจุบัน : </span>
                                    {#if camList.promotion_olduser_open == 'O'}
                                    <span class="text-success"><Fa icon={faCheckDouble} /> </span>
                                    {:else}
                                    <span class="text-danger"><Fa icon={faTimesCircle} /> </span>
                                    {/if}
                                <br />
                                <span>เงื่อนไขฝาก : </span><br />
                                {#each camList.promotion_value as itmdep}
                                    &nbsp;&nbsp;&nbsp;<span class="text-warning">{itmdep.pro_cash} - {itmdep.pro_to}</span> รับ <span class="text-warning">{itmdep.pro_total}{#if camList.promotion_type == 'P'}%{:else}บาท{/if}
                                    </span>ถอนได้ <span class="text-warning">{#if itmdep.pro_withdraw==0}ไม่จำกัด{:else}{itmdep.pro_withdraw}บาท{/if}</span>
                                    <br />
                                {/each}
                                
                                <span>เงื่อนไขถอน : </span><br />
                                {#if camList.promotion_withdraw_type == 'T'}
                                    &nbsp;&nbsp;&nbsp;<span class="text-warning">{#if camList.promotion_withdarwlimit==0}ไม่จำกัด{:else}{camList.promotion_withdarwlimit}{/if}</span> เทิร์น
                                {:else}
                                    &nbsp;&nbsp;&nbsp;<span class="text-warning">{#if camList.promotion_withdarwlimit==0}ไม่จำกัด{:else}{camList.promotion_withdarwlimit}{/if}</span> บาท
                                {/if}
                                <br />
                                <span>ค่ายเกมที่เล่นได้ : </span><br />
                                <div class="row">
                                    <div class="col text-center">
                                        {#each camList.promotion_platform as itmgame}
                                            <img src="./assets/platform/{itmgame}.png" class=" w-25" alt="{itmgame}">
                                        {/each}
                                    </div>
                                </div>
                                
                            </div>
                            <div class="col-12 mb-5 text-center">
                                <span class="text-danger">** โปรโมชั่นจะถูก <span class="text-warning">"ยกเลิก"</span> หลังจาก 30 นาที<br /><b>หากไม่เติมเงินเข้ามา</b></span>
                                <button type="button" class="btn btn-warning btn-sm w-100" on:click={() => checkPromotion()}>รับโปรโมชั่น</button>
                            </div>
                            {/if}
                        </div>
                        
                    </div>
                </div>
                {/if}
            </div>
    </div>
</div>
<div class="themes-home-section" style="display: none;display:flex;">
    
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
</style>